import { nanoid } from 'nanoid'
import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { type IEmailToSmsGroup } from './emailToSmsPageStore'

export class EmailToSmsActionStore {
  constructor() {
    makeAutoObservable(this)
  }
  onDeleteMapping = (
    callback: (group: IEmailToSmsGroup) => Promise<void>,
    group: IEmailToSmsGroup
  ) => {
    const id = nanoid()
    modalStore.addModal({
      id: id,
      type: ModalTypeList.ALERT,
      title: 'Delete mapping?',
      desc: 'This action cannot be undone',
      primaryAction: {
        text: 'Delete',
        onAction: async () => {
          try {
            await callback(group)
            toastStore.add({
              type: 'success',
              title: 'Email removed',
            })
            modalStore.closeModal(id)
          } catch (error) {
            logger.error(error)
          }
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(id)
        },
      },
    })
  }
}
